if (!document.querySelector(".js-header").classList.contains("stop-hover")) {
  window.addEventListener("scroll", function () {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const header = document.querySelector(".js-header");
    if (scrollTop > 50) {
      header.classList.add("fixed");
    } else {
      header.classList.remove("fixed");
    }
  });
}

const fixedHeader = document.querySelector(".js-fixed-header");
const header = document.querySelector(".js-header");
if (fixedHeader && header) {
  header.classList.add('active');
  fixedHeader.style.height = header.offsetHeight + "px";
}

function handleOpen(selectorBtn, selectorTarget) {
  document.querySelectorAll(selectorBtn).forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      const el = document.querySelector(selectorTarget);
      if (!el) return;

      el.classList.add('display');
      setTimeout(() => el.classList.add('show'), 50);
      document.body.style.overflow = 'hidden';
    });
  });
}

function handleClose(selectorBtn, selectorTarget) {
  document.querySelectorAll(selectorBtn).forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      const el = document.querySelector(selectorTarget);
      if (!el) return;

      el.classList.add('closing');
      setTimeout(() => {
        el.classList.remove('display', 'show', 'closing');
        document.body.style.overflow = 'visible';
      }, 300);
    });
  });
}

// Contact Sidebar
handleOpen('.js-open-sidebar-contact', '.js-sidebar-contact');
handleClose('.js-close-sidebar-contact', '.js-sidebar-contact');

// Menu Sidebar
handleOpen('.js-open-sidebar-menu', '.js-sidebar-menu');
handleClose('.js-close-sidebar-menu', '.js-sidebar-menu');

// Search Popup
handleOpen('.js-open-popup-search', '.js-search-popup');
handleClose('.js-close-search-popup', '.js-search-popup');

// Canvas cart
handleOpen('.js-open-canvas-cart', '.js-canvas-cart');
handleClose('.js-close-canvas-cart', '.js-canvas-cart');

// Menu
(function () {
  const menu = document.querySelector(".js-mobile-menu");
  if (!menu) return;

  const headerEl = document.querySelector(".js-header");
  const carousel = menu.querySelector(".js-mobile-menu-carousel");
  if (!carousel) return;

  const splide = new Splide(carousel, {
    type: "slide",
    perPage: 1,
    arrows: false,
    pagination: false,
    drag: true,
    speed: 300,
    autoHeight: true
  });
  splide.mount();

  const secondStep = menu.querySelector(".js-second-step-mobile-menu");
  const panels = secondStep ? secondStep.querySelectorAll(".js-second-step-mobile-menu-item") : [];

  const processedIds = new Set();

  document.querySelectorAll(".js-get-megamenu").forEach(function (menuItem) {
    var id = menuItem.getAttribute('data-id');
    var megaMenu = document.querySelector(".js-megamenu[data-id='" + id + "']");

    if (megaMenu) {
      menuItem.insertAdjacentHTML('beforeend', megaMenu.innerHTML);
    }

    if (megaMenu && !processedIds.has(id)) {
      processedIds.add(id);

      var secondStepMenu = document.querySelector(".js-second-step-mobile-menu-item[data-index='" + id + "']");
      if (secondStepMenu) {
        var clone = menuItem.cloneNode(true);
        clone.classList.remove("js-get-megamenu");
        secondStepMenu.appendChild(clone);
      }

      var firstStepItem = document.querySelector(".js-mobile-menu-item[data-index='" + id + "']");
      if (firstStepItem && !firstStepItem.querySelector(".lnil.lnil-chevron-right")) {
        firstStepItem.insertAdjacentHTML(
          "beforeend",
          ' <svg class="lnil lnil-chevron-right" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M9 6L15 12L9 18" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/></svg>'
        );
      }
    }
  });

  function showPanel(index) {
    if (!secondStep) return;
    panels.forEach(p => {
      const isActive = p.getAttribute("data-index") === String(index);
      p.classList.toggle("active", isActive);
    });
  }

  if (panels.length) {
    const preset = secondStep.querySelector(".js-second-step-mobile-menu-item.active");
    panels.forEach(p => p.classList.remove("active"));
    (preset || panels[0]).classList.add("active");
  }

  document.addEventListener("click", function (e) {
    const firstStepItem = e.target.closest(".js-mobile-menu-item");
    if (firstStepItem && menu.contains(firstStepItem)) {
      const hasChevronSvg = !!firstStepItem.querySelector("svg");
      if (hasChevronSvg) {
        const index = firstStepItem.getAttribute("data-index");
        const hasPanel = !!secondStep?.querySelector(`.js-second-step-mobile-menu-item[data-index="${index}"]`);
        if (hasPanel) {
          showPanel(index);
          splide.go(1);
          e.preventDefault();
          return;
        }
      }
    }

    const back = e.target.closest(".js-go-to-previous-mobile-menu");
    if (back && menu.contains(back)) {
      splide.go(0);
      e.preventDefault();
      return;
    }

    const toggleBtn = e.target.closest(".js-open-mobile-menu");
    if (toggleBtn) {
      menu.classList.toggle("active");
      toggleBtn.classList.toggle("active");
      headerEl?.classList.toggle("with-mobile-menu");
      document.body.style.overflow = menu.classList.contains("active") ? "hidden" : "visible";
      e.preventDefault();
    }
  });
})();

if (window.Shopify && Shopify.designMode) {
  ['shopify:block:select']
    .forEach(eventName => {
      document.addEventListener(eventName, function (e) {
        const blockId = e?.detail?.blockId;
        if (!blockId) return;

        document.querySelectorAll('.js-get-megamenu').forEach(el => {
          el.classList.remove('active');
        });

        const blockEl = document.querySelector(`[data-block-id="${blockId}"]`);
        if (!blockEl) return;

        const hitMega = blockEl.closest('.js-get-megamenu');

        if (hitMega) {
          hitMega.classList.add('active');
        }

        document.querySelectorAll('.js-get-megamenu').forEach(function (menuItem) {
          const id = menuItem.getAttribute('data-id');
          const megaMenu = document.querySelector(`.js-megamenu[data-id="${id}"]`);
          if (megaMenu) {
            menuItem.innerHTML = '';
            menuItem.insertAdjacentHTML('beforeend', megaMenu.innerHTML);

            if (typeof initializeFadeInObserver === 'function') {
              initializeFadeInObserver();
            }
          }
        });
      });
    });
}

if (window.Shopify && Shopify.designMode) {
  ['shopify:block:select']
    .forEach(eventName => {
      document.addEventListener(eventName, function (e) {
        const blockId = e?.detail?.blockId;
        if (!blockId) return;

        const blockEl = document.querySelector(`[data-block-id="${blockId}"]`);
        if (!blockEl) return;

        const configs = [
          { wrap: '.js-sidebar-contact',    openClass: 'display', showClass: 'show' },
          { wrap: '.js-sidebar-menu',       openClass: 'display', showClass: 'show' },
          { wrap: '.js-search-popup',       openClass: 'display', showClass: 'show' },
          { wrap: '.js-canvas-cart',        openClass: 'display', showClass: 'show' }
        ];

        configs.forEach(cfg => {
          document.querySelectorAll(cfg.wrap).forEach(wrapper => {
            if (wrapper.contains(blockEl)) {
              wrapper.classList.add(cfg.openClass);
              setTimeout(() => wrapper.classList.add(cfg.showClass), 50);
            }
          });
        });
      });
    });
}